import React, { useState, useEffect } from 'react';
import { mapData } from '../datamapper';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import {Link} from 'react-router-dom';


import { useAuth } from "./authcontext";

import { useSearch } from './searchcontext';
 
import CoverOverlay from './overlay_cover';
import { useCart } from "./context4cart";
import '../productdetails.css'

import CartOverlay from './overlay_cart';
import PdfViewerOverlay from './overlay_pdf';
import VideoOverlay from './overlay_video';
import AudioOverlay from './overlay_audio';




const DetailPage = () => {

    const { ean } = useParams();
    const {searchParams, setSearchParams} = useSearch(); 
    const [product, setProduct] = useState(null);
    const [texte, setText] = useState(null);
    const { sqlID, callerID, sessionID} = useParams();
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);
    const [isErweitert, setIsErweitert] = useState(false);
    const [autorIsVisible, setAutorIsVisible] = useState(false);
    const [autorIsErweitert, setAutorIsErweitert] = useState(false);
    const [biblioIsErweitert, setBiblioIsErweitert] = useState(false);
    const [biblioIsVisible, setBiblioIsVisible] = useState(false);

    const [openRabattId, setOpenRabattId] = useState(null);


    const [menge, setMenge] = useState(1);
    const [vormerker, setVormerker] = useState(false);
    const [bestellzeichen, setBestellzeichen] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    const { fetchWarenkorb } = useCart();
    const {fetchWishlist} = useCart();
    const [showCartOverlay, setShowCartOverlay] = useState(false);
    const [coversToShow, setCoversToShow] = useState(3);

    const {user} = useAuth();
    


    const openOverlay = () => setShowOverlay(true);
    const closeOverlay = () => setShowOverlay(false);

    
    const [showOverlay, setShowOverlay] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [audioUrl, setAudioUrl] = useState(null);

    const [videoUrl, setVideoUrl] = useState(null);

    const [showPreview, setShowPreview] = useState(false);
    const [showAudioPreview, setshowAudioPreview] = useState(false);

    
    const pdfs = product?.pdf ? sortByLfn(product.pdf) : [];
    const videos = product?.video ? sortByLfn(product.video) : [];
    const audios = product?.audio ? sortByLfn(product.audio) : [];
    

    const [showPdfList, setShowPdfList] = useState(false);
    const [showVideoList, setShowVideoList] = useState(false);
    const [showAudioList, setShowAudioList] = useState(false);

    const openCartOverlay = () => setShowCartOverlay(true);
    const closeCartOverlay = () => setShowCartOverlay(false);
    
    // Textmapping get-texte
    const mapTexte = (data) => {
        if (data.records && data.records.length > 0) {
            return data.records.map((texte) => ({
                textisbn: texte.isbn,
                autoreninfo: texte.a,     // Author info
                zusatztext: texte.z,      // Zusatztext
                leseprobe: texte.l,       // Leseprobe
                inhalt: texte.i,          // Inhalt
                kurztext: texte.k,        // Kurztext
                schlagzeile: texte.s      // Schlagzeile
            }));
        } else {
            
            console.error('Keine Inhalte in der Response');
            return [];
        }
    };

    
    
    // Anzeige
    const anzeigeSeiten = (formatangaben) => {
        return formatangaben.replace('S.', 'Seiten');
    }

    const anzeigeCm = (format) => {
    return format
        .split(' x ')
        .map(value => value.replace('.', ',') + ' cm')
        .join(' x ');
    }         


    const preisAnzeige = (preis) => {
        return preis.toFixed(2).replace('.',',');
    }

    const formatDate = (erscheinungsdatum) => {
        const year = erscheinungsdatum.substring(0, 4);
        const month = erscheinungsdatum.substring(4, 6);
        const day = erscheinungsdatum.substring(6, 8);
        return `${day}.${month}.${year}`;
    };
    
    const anzeigeSprache = (sprache) => {
        return sprache
        ?.replace('GER', 'deutsch')
        .replace('ENG', 'Englisch')
        .replace('FRE', 'Französisch')
        .replace('SPA', 'Spanisch')
    }

    

    const fetchProduct = async () => {
        if (product) return; 
        try {
            console.log('fetching product with ean:', ean);
            const response = await fetch( `/search?ean=${ean}`);
            if (!response.ok) {
                throw new Error('Failed to fetch product details');
            }
            const data = await response.json();
            const mappedData = mapData(data); // Map data using your data mapper
            console.log('Produktdetails: ', mappedData);

            setProduct(mappedData);
        } catch (error) {
            console.error('Error fetching product details:', error);
        }
    };

    
   


    const fetchText = async (ean) => {
        try {
            console.log('Texte holen für EAN:', ean);
            const sqlID = "1000136";
            const response = await fetch(`/api-get-texte/${sqlID}/${user.aml}/${user.session_id}/${ean}/`);
            
            // 👇 Fetch raw bytes instead of auto-decoding
            const arrayBuffer = await response.arrayBuffer();

            // 👇 Try decoding manually as Windows-1252
            const decoder = new TextDecoder("windows-1252");
            const decodedText = decoder.decode(arrayBuffer);



            const data = JSON.parse(decodedText);
            console.log('Received Data:', data);  // Inspect the received data
            const mappedTexte = mapTexte(data);   // Map the data
            setText(mappedTexte);                 // Update state with mapped data
            console.log('Texte geholt', mappedTexte);
        } catch (error) {
            console.error('Error fetching texts:', error);
        }
    };
   

/*
    const fetchText = async (ean) => {
        try {
            console.log('Texte holen für EAN:', ean);
            const sqlID = "1000136";
            const response = await fetch(`/get-texte/${sqlID}/${user.aml}/${user.session_id}/${ean}/`);

            const data = await response.json();
            console.log('Received Data:', data);  // Inspect the received data
            const mappedTexte = mapTexte(data);   // Map the data
            setText(mappedTexte);                 // Update state with mapped data
            console.log('Texte geholt', mappedTexte);
        } catch (error) {
            console.error('Error fetching texts:', error);
        }
    };*/

    useEffect(() => {
        if (ean) {
            console.log('Fetching product for EAN:', ean);
            fetchProduct();
            fetchText(ean);
        }
    }, [ean])

    
    /*useEffect(() => {
      
        if (product && product.ean) {
            console.log('Fetching Texts for EAN:', product.ean);
            console.log('ISBN:', texte.isbn)
            
            fetchText(product.ean);
        } else {
            console.log('product or EAN not available yet');
        }
    }, [product]);*/




    //{preisAnzeige(item.preis)}
  

    if (!product) {
        return <div className="loadingGif"><img src="/assets/img/icons/loadingBook.gif" /></div>;
    }

    console.log('Current Index:', currentIndex);
    console.log('Product:', product);


    const zusatzCover = Array.isArray(product.cover) && product.cover.length > 1 ? product.cover.slice(1) : [];
    

    console.log('Liste Cover:', zusatzCover);
    console.log('Product cover array:', product.cover);
    console.log("Full product:", product);
    console.log('Product pdf array:', product.pdf);

    console.log("PDFs from product:", product?.pdf);
    console.log("Sorted PDFs:", pdfs);

    const nextCover = (covers, setCurrentIndex) => {
        if (covers.length > 1) {
            setCurrentIndex((prevIndex) => {
                const newIndex = (prevIndex + 1) % covers.length;
                console.log('Next Slide:', newIndex);
                return newIndex;
            });
        }
    };
    
    const prevCover = (covers, setCurrentIndex) => {
        if (covers.length > 1) {
            setCurrentIndex((prevIndex) => {
                const newIndex = (prevIndex - 1 + covers.length) % covers.length;
                console.log('Previous Slide:', newIndex);
                return newIndex;
            });
        }
    };


    const toggleTextBeschreibungMobile = () => {
        setIsVisible(!isVisible);
        setIsErweitert(!isErweitert);
    }

    const toggleTextAutorMobile = () => {
        setAutorIsVisible(!autorIsVisible);
        setAutorIsErweitert(!autorIsErweitert);
    }

    const toggleBibliopraphieMobile = () => {
        setBiblioIsVisible(!biblioIsVisible);
        setBiblioIsErweitert(!biblioIsErweitert)
    }

    //different from toggleRabatt in search, only one item here

    const toggleRabatt = (isbn) => {

        setOpenRabattId(prev =>
            prev === isbn ? null : isbn
        );
    
    }
    function sortByLfn(arr) {
        return [...arr].sort((a, b) => Number(a.lfn) - Number(b.lfn));
      }
  
  
      const handleAddToCart = async (e, isbn) => {
        e.preventDefault();
      
        
        const session_id = user?.session_id;

        const knr = user?.aml;
      
        const formData = new URLSearchParams();
        formData.append("knr", knr);
        formData.append("schnell_isbn", isbn);
        formData.append("schnell_menge", menge);
        //formData.append("schnell_vormerken", vormerker ? "true" : "false");
        formData.append("schnell_vormerken", vormerker ? "on" : "");
        formData.append("schnell_bestellzeichen", bestellzeichen || "");
        formData.append("session_id", session_id);
      
        try {
          const response = await fetch("/api-add2wk", {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
          });
      
          const result = await response.json();
          console.log("Result:", result);
      
          //alert("Artikel wurde(n) in den Warenkorb gelegt");
      
          if (typeof fetchWarenkorb === "function") {
            fetchWarenkorb(); // refresh cart
          }
      
          // Reset inputs
          setMenge("1");
          setBestellzeichen("");
          setVormerker(false);
        } catch (err) {
          console.error("Error:", err);
          alert("Fehler beim Hinzufügen zum Warenkorb.");
        }
      };

      const handleAddToWishlist = async (e, isbn) => {
        e.preventDefault();
      
        
        const session_id = user?.session_id;

        const caller = user?.aml;
      
        const formData = new URLSearchParams();
        formData.append("caller", caller);
        formData.append("isbn", isbn);

        formData.append("bestellzeichen", bestellzeichen || "");
        formData.append("session_id", session_id);
      
        try {
          const response = await fetch("/api-savemerkzettel", {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
          });
      
          const result = await response.json();
          console.log("Result:", result);
      
          //alert("Artikel wurde(n) auf die Merkliste gelegt");
      
          if (typeof fetchWishlist === "function") {
            fetchWishlist(); // refresh cart
          }
      
          // Reset inputs
          setBestellzeichen("");
        } catch (err) {
          console.error("Error:", err);
          alert("Fehler beim Hinzufügen zur Merkliste.");
        }
      };
    console.log(product); 


    /* Themenclick*/ 


    const handleTopicClick = (themaCode) => {
        const queryParams = `themen=${encodeURIComponent(themaCode)}`;
        
      
        fetch(`/search?${queryParams}&count=20&offset=0`)
          .then(response => response.json())
          .then(data => {
            const mappedData = mapData(data);
      
            // Reset search params
            const newSearchParams = { themen: themaCode };
      
            // Store  topic filter
            sessionStorage.setItem('searchParams', JSON.stringify(newSearchParams));
            sessionStorage.setItem('nexusSelect', JSON.stringify(mappedData));
            sessionStorage.setItem('offset', '0');
            sessionStorage.setItem('totalCount', data.totalCount);
            sessionStorage.setItem('preloadedSearch', 'true');
            
      
            navigate(`/suche?${queryParams}`);
          })
          .catch(error => {
            console.error('Preloading failed:', error);
            navigate(`/suche?${queryParams}`);
          });
      };



    return (    <div className="mainContentWrapper">
                    <div className="contentContainer">
                    {product ? (
                            product.map((product) => (            
                                        <div> 
                                                                                                                    
                                            <div class="parentDetailViewGrid">

                                                <div className="gridCover umBorderRight">
                                                    <div className="containerBibCover">     
                                                        <div className="detailCoverContainer">
                                                            {Array.isArray(product.cover) && product.cover.length > 0 ? (
                                                            
                                                                <a onClick={openOverlay}>
                                                                        <img className="card-img-top image-height" src={product.cover[0]} alt="" />
                                                                </a>
                                                            ) : (
                                                                
                                                                <img className="card-img-top image-height" src="/assets/img/icons/noImage.png" alt="" />
                                                            )}
                                                        </div>

                                                        {showOverlay && (
                                                            <CoverOverlay
                                                                covers={product.cover}
                                                                onClose={closeOverlay}
                                                            />
                                                        )}

                                                        {Array.isArray(product.cover) && product.cover.length > 1 && (
                                                            <div className="coverCarouselContainer">
                                                        
                                                                    <div className="additionalCoverCount">
                                                                        {`${product.cover.length - 1} weitere Abbildung${product.cover.length - 1 === 1 ? "" : "en"}`}
                                                                    </div>
                                                        
                                                                <button onClick={() => prevCover(product.cover.slice(1), setCurrentIndex)} className="carouselButton prevButton" />
                                                        
                                                   
                                                                <div className="coverCarouselWrapper">  
                                                                        <div className="coverCarouselContent"
                                                                            style={{ transform: `translateX(-${currentIndex * 100 / product.cover.slice(1).length}%)` }}
                                                                        >
                                                                                
                                                                                    <>
                                                                                        
                                                                                        {product.cover.slice(1).map((cover, index) => (
                                                                                            <div className="coverCarouselItem" key={index}>  
                                                                                                <a onClick={openOverlay}>
                                                                                                    <div className="additionalCoverPreview">
                                                                                                        <img className="detailCover" src={cover} alt="" />
                                                                                                    </div>
                                                                                                </a>
                                                                                            </div>
                                                                                        ))}
                                                                                    </>
                                                                                       
                                                                        </div>

                                                                </div>

                                                           
                                                                <button onClick={() => nextCover(product.cover.slice(1), setCurrentIndex)} className="carouselButton nextButton" />
                                                             
                                                            </div>
                                                        
                                                        )}                                                        
                                                        
                                                       
                                                                {product.pdf && product.pdf.length > 0 && (
                                                                    <div className='pdfPreview'>
                                                                        <div
                                                                            style={{
                                                                                width: "100%",
                                                                                marginBottom: "15px",
                                                                                flexDirection: "column",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        >
                                                                                <button onClick={() => setShowPdfList(!showPdfList)} className="umbButton">Leseprobe</button>
                                                                                {showPdfList && (
                                                                                <ul>
                                                                                    {product.pdf
                                                                                    .slice()
                                                                                    .sort((a, b) => a.lfn.localeCompare(b.lfn))
                                                                                    .map((pdf, idx) => (
                                                                                        <li key={idx} style={{float: "none"}}>
                                                                                        <button className="umbButton"onClick={() => setPdfUrl(pdf.url)}>
                                                                                            {pdf.name || `PDF ${pdf.lfn}`}
                                                                                        </button>
                                                                                        </li>
                                                                                    ))}
                                                                                </ul>
                                                                                )}
                                                                            </div>
                                                                            {pdfUrl && <PdfViewerOverlay pdfUrl={pdfUrl} onClose={() => setPdfUrl(null)} />}
                                                                    </div>
                                                                    )}
                                                          
                                                           
              
                                              
                                                               
                                                         {videoUrl && (
                                                            <VideoOverlay
                                                                videoUrl={videoUrl}
                                                                onClose={() => setVideoUrl(null)}
                                                            />
                                                        )}
                                                         
                                                            <div className='videoPreview'>

                                                                {product.video && product.video.length > 0 && (
                                                                    <div
                                                                        style={{
                                                                            width: "100%",
                                                                            marginBottom: "15px",
                                                                            flexDirection: "column",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        <button 
                                                                            onClick={() => setShowVideoList(!showVideoList)}
                                                                            className='umbButton'
                                                                        >
                                                                        Video
                                                                        </button>

                                                                        {showVideoList && (
                                                                        <ul>
                                                                            {product.video
                                                                            .slice()
                                                                            .sort((a, b) => a.lfn.localeCompare(b.lfn))
                                                                            .map((video, idx) => (
                                                                                <li key={idx} style={{ marginBottom: "1rem" }}>
                                                                                <div style={{ marginBottom: "0.25rem" }}>
                                                                                    {video.name || `Video ${video.lfn}`}
                                                                                </div>
                                                                                <video
                                                                                    src={video.url}
                                                                                    controls
                                                                                    style={{ width: "95%", cursor: "pointer" }}
                                                                                />
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                        )}
                                                                    </div>
                                                                    )}
                                                                </div>   

                                                   

                                                    <div className='audioPreview'>

                                                        {product.audio && product.audio.length > 0 && (
                                                            <div
                                                                style={{
                                                                    width: "100%",
                                                                    marginBottom: "15px",
                                                                    flexDirection: "column",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                <button 
                                                                    onClick={() => setShowAudioList(!showAudioList)}
                                                                    className='umbButton'
                                                                >
                                                                Audio
                                                                </button>

                                                                {showAudioList && (
                                                                <ul>
                                                                    {product.audio
                                                                    .slice()
                                                                    .sort((a, b) => a.lfn.localeCompare(b.lfn))
                                                                    .map((audio, idx) => (
                                                                        <li key={idx} style={{ marginBottom: "1rem" }}>
                                                                        <div style={{ marginBottom: "0.25rem" }}>
                                                                            {audio.name || `Audio ${audio.lfn}`}
                                                                        </div>
                                                                        <audio
                                                                            src={audio.url}
                                                                            controls
                                                                            style={{ width: "95%", cursor: "pointer" }}
                                                                        />
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                                )}
                                                            </div>
                                                            )}
                                                        </div>              
















                                                   



                                                       
                                                            
                                                    </div>

                                                    
                                                </div>



                                                <div className="gridDetails"> 
                                                    
                                                        <div className="detailBaseInfo">
                                                             <h3 className="detailTitel"><b>{product.titel}</b></h3>
                                                            <br/>          
                                                            <h5>{product.untertitel}</h5>
                                                           
                                                            <br/>
                                                            <div>{product.autor}</div>
                                                            <div>{product.verlag}</div>
                                                         

                                                            {product.produktgruppe && (
                                                               <div> Produktgruppe: {product.produktgruppe} </div>    
                                                            )}
                                                            
                                                            Erscheinungsdatum: {formatDate(product.erscheinungsdatum)}
                                                          
                                                            {product.herausgeber  && ( 
                                                                <div className="herausgeberDiv">Herausgeber: {product.herausgeber}</div>
                                                            )}
                                                            <br />
                                                            {product.illustration && (
                                                                <div className="illustrationDiv">Illustrationen: {product.illustration}</div>
                                                            )}
                                                             <br />
                                                            {product.remissionsrecht && (
                                                                <div className="remissionsDiv">Remissionsrecht: {product.remissionsrecht_zusatz}</div>
                                                            )}
                                                           
                                                           {Array.isArray(product.themen) && product.themen.length > 0 && (
                                                                <div className="product-themen">
                                                                    <span>Themen:&nbsp;</span><br />
                                                                    {product.themen.map((code, index) => {
                                                                    const label =
                                                                        product.themen_bezeichnungen?.[index] || code;

                                                                    return (
                                                                        <span
                                                                        key={code}
                                                                        className="product-thema-link"
                                                                        onClick={() => handleTopicClick(code)}
                                                                        style={{ cursor: 'pointer', color: '#008C8D' }}
                                                                        >
                                                                        {label}
                                                                        {index < product.themen.length - 1 && ', '}
                                                                        </span>
                                                                    );
                                                                    })}
                                                                </div>
)}

                                                            <br/>
                                                        <div className="detailButtonAreaMobile"> 
                                                    
                                                            <div className="detailMeldePreis">
                                                                <div className="">
                                                                   
                                                                    

                                                                <div style={{  gap: "8px"}}>
                                                                    <button className="showRabattButton" onClick={() => toggleRabatt(product.isbn)} >
                                                                        <b>{preisAnzeige(product.preis)} €</b>
                                                                    </button>  

                                                                        {openRabattId === product.isbn && (
                                                                            <div className="rabatt">
                                                                                Rabatt:  {Number((Number(product.rabatt) * (2 / 3)).toFixed(2))} %
                                                                               
                                                                            </div>
                                                                        )}  
                                                                  </div>    
                                                                </div> 

                                                                <div>
                                                                    Mwst: {product.mwst_wert}
                                                                </div>         

                                                                <div className={product.meldetext}>
                                                                    {product.meldetext}
                                                                </div>    
                                                                <br />
                                                                
                                                            </div>
                                                            <div className="buttonContainerMobile">    
                                                                <button className="umbButtonIconList"> 
                                                                    <span className="iconListHover"></span>
                                                                </button> 
                                                                <button
                                                                        className="umbButtonIconCart" 
                                                                        onClick={openCartOverlay}
                                                                    > 
                                                                        <span className="iconCartHover"></span>
                                                                    </button> 

                                                                    {showCartOverlay && (
                                                                            <CartOverlay isOpen={showCartOverlay}
                                                                                isbn={product.isbn}
                                                                                titel={product.titel}
                                                                                preis={product.preis}
                                                                                autor={product.autor}
                                                                                onClose={closeCartOverlay}
                                                                            /> 
                                                                    )}
                                                                        
                                                                            
                                                                       
                                                                   

                                                                <button className="umbButtonIconBackToSearch" onClick={() => navigate('/suche')}> 
                                                                    <span className="iconSearchHover"></span>
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <div className="bibliographieContainerMobile"> 

                                                        <div className="showThisOnlyMobile">
                                                                <Link onClick={toggleBibliopraphieMobile}>
                                                                    <div className="detailTextHeadlines umBorderTop umBorderLeft">
                                                                        <h4 className="detailH">Bibliographie</h4>
                                                                        <div className="iconOnlyMobile">
                                                                            {biblioIsErweitert ? (                
                                                                                <>       
                                                                                    <img src="/assets/img/icons/minus_32_umb.png"/>
                                                                                </> 
                                                                                ) : (
                                                                                <>                
                                                                                    <img src="/assets/img/icons/plus_32_umb.png"/>
                                                                                </>     

                                                                                )
                                                                            }
                                                                        </div>
                                                                    </div>  
                                                                </Link>
                                                        </div>
                                                        <div className={`biblioBgraphieMobile umBorderLeft ${biblioIsVisible  ? 'visible' : 'hidden'}`}>
                                                                {product.artikelnummer && (    
                                                                            <div> 
                                                                                Artikelnummer: {product.artikelnummer} 
                                                                            </div>
                                                                    )}   
                                                                    {product.isbn && (      
                                                                            <div>
                                                                                ISBN/EAN: {product.isbn}
                                                                            </div>
                                                                    )} 
                                                                    {product.sprache && ( 
                                                                            <div>
                                                                                Sprache: {anzeigeSprache(product.sprache)}
                                                                            </div>
                                                                    )} 
                                                                    {product.formatangaben && ( 
                                                                            <div>
                                                                                {anzeigeSeiten(product.formatangaben)}
                                                                                
                                                                            </div>
                                                                    )}   
                                                                    {product.format && (
                                                                            <div className="formatDiv">
                                                                                Format: {anzeigeCm(product.format)}
                                                                            </div>
                                                                    )}    

                                                                    {product.einband && ( 
                                                                            <div>
                                                                                Einband: {product.produktform}
                                                                            </div>
                                                                    )}  
                                                            </div>        
                                                        </div>

                                                        {texte && texte.length > 0 ? (
                                                            texte.map((texte, index) => (
                                                            
                                                                <div key={index}>

                                                                
                                                                    
                                                                    {texte.inhalt && 
                                                                        <div>
                                                                            <h4>Inhalt</h4>  
                                                                            {texte.inhalt}
                                                                        </div>
                                                                    }
                                                                
                                                                
                                                                    {texte.zusatztext && 
                                                                        <div>
                                                                            <div className="showThisOnlyMobile">
                                                                                <Link onClick={toggleTextBeschreibungMobile}>
                                                                                    <div className="detailTextHeadlines umBorderTop umBorderLeft">
                                                                                        <h4 className="detailH">Beschreibung</h4>
                                                                                        <div className="iconOnlyMobile">
                                                                                            {isErweitert ? (                
                                                                                                <>       
                                                                                                    <img src="/assets/img/icons/minus_32_umb.png"/>
                                                                                                </> 
                                                                                                ) : (
                                                                                                <>                
                                                                                                    <img src="/assets/img/icons/plus_32_umb.png"/>
                                                                                                </>     

                                                                                                )
                                                                                            }
                                                                                        </div>
                                                                                    </div>  
                                                                                </Link>
                                                                            </div>

                                                                            <div className={`textBeschreibungMobile umBorderLeft ${isVisible  ? 'visible' : 'hidden'}`}>
                                                                                {texte.zusatztext}
                                                                            </div>  
                                                                            
                                                                            <div className="zusatzTextDesk">
                                                                                <h4>Beschreibung</h4>
                                                                                {texte.zusatztext}
                                                                            </div> 
                                                                        </div>
                                                                    }  

                                                                    
                                                                {texte.autoreninfo &&
                                                                        <div>
                                                                                <div className="showThisOnlyMobile">
                                                                                <Link onClick={toggleTextAutorMobile}>
                                                                                    <div className="detailTextHeadlines umBorderTop umBorderLeft">
                                                                                        <h4 className="detailH">Autorenportrait</h4>
                                                                                        <div className="iconOnlyMobile">
                                                                                            {autorIsErweitert ? (                
                                                                                                <>       
                                                                                                    <img src="/assets/img/icons/minus_32_umb.png"/>
                                                                                                </> 
                                                                                                ) : (
                                                                                                <>                
                                                                                                    <img src="/assets/img/icons/plus_32_umb.png"/>
                                                                                                </>     

                                                                                                )
                                                                                            }
                                                                                        </div>
                                                                                    </div>  
                                                                                </Link>
                                                                            </div>

                                                                            <div className={`textAutorenInfoMobile ${autorIsVisible  ? 'visible' : 'hidden'}`}>
                                                                                {texte.autoreninfo}
                                                                            </div>  
                                                                        </div>
                                                                    
                                                                    }

                                                                
                                                                </div>
                                                               
                                                            ))
                                                        ) : (
                                                            <p></p>
                                                        )
                                                    }
                                                                
                                                        
                                                        </div>    
                                                   
                                                    
                                                        <div className="detailButtonArea">
                                                            <div className="detailBibliographie zusatzTextDesk umBorderLeft">
                                                                {product.artikelnummer && (    
                                                                        <div> 
                                                                            Artikelnummer: {product.artikelnummer} 
                                                                        </div>
                                                                )}   
                                                                {product.isbn && (      
                                                                        <div>
                                                                            ISBN/EAN: {product.isbn}
                                                                        </div>
                                                                )} 
                                                                {product.sprache && ( 
                                                                        <div>
                                                                            Sprache: {anzeigeSprache(product.sprache)}
                                                                        </div>
                                                                )} 
                                                                {product.formatangaben && ( 
                                                                        <div>
                                                                            
                                                                            {anzeigeSeiten(product.formatangaben)}
                                                                        </div>
                                                                )}   
                                                                {product.format && (
                                                                        <div className="formatDiv">
                                                                         Format: {anzeigeCm(product.format)}
                                                                        </div>
                                                                )}    

                                                                {product.einband && ( 
                                                                        <div>
                                                                            Einband: {product.produktform}
                                                                        </div>
                                                                )}         
                                                            </div> 
                                                            <div className="detailMeldePreis umBorderLeft">
                                                            <div style={{}}>
                                                                <button className="showRabattButton detailPreisStyle" onClick={() => toggleRabatt(product.isbn)} >
                                                                    
                                                                        {preisAnzeige(product.preis)} €
                                                                        
                                                                    </button>  

                                                                        {openRabattId === product.isbn && (
                                                                            <div className="rabatt">
                                                                                Rabatt:  {Number((Number(product.rabatt) * (2 / 3)).toFixed(2))} %
                                                                            </div>
                                                                        )}  
                                                                   </div>    
                                                                <br/>
                                                                 <div>
                                                                    Mwst: {product.mwst_wert}
                                                                </div> 
                                                                <br/>
                                                                <div className={product.meldetext}>
                                                                    <b>{product.meldetext}</b>
                                                                </div>    
                                                                <br />
                                                                
                                                            </div>
                                                            <div className="desktopButtonNavDetailPage umBorderLeft">    
                                                             
                                                                <form className='umbBorderEverywhere' key={product.isbn} onSubmit={(e) => handleAddToCart(e, product.isbn)} >
                                                                
                                                                    <select className="desktopButtonItem" value={menge} onChange={(e) => setMenge(e.target.value)}>
                                                                        {[...Array(10)].map((_, i) => (
                                                                        <option key={i + 1} value={i + 1}>
                                                                            Menge: {i + 1}
                                                                        </option>
                                                                        ))}
                                                                    </select>

                                                                    <div className='cartOverlayField cartOverlayBZ cartOverlayContentItem'>
                                                                            <input type="text" value={bestellzeichen} onChange={(e) => setBestellzeichen(e.target.value)} placeholder='Bestellzeichen' />
                                                                    </div> 

                                                                    <div className='desktopButtonItem styledCheckbox'><label> Vormerken:
                                                                        <input type="checkbox" checked={vormerker} onChange={(e) => setVormerker(e.target.checked)} />
                                                                        <span class="customCheckbox"></span>
                                                                        </label>
                                                                    </div>
                                                                    
                                                                    <button className="umbButtonReverse desktopButtonItem" type="submit" disabled={product.meldetext==='vergriffen'}> 
                                                                        <span>In den Warenkorb</span>
                                                                    </button>
                                                                </form>    

                                                                <button className="umbButton desktopButtonItem" onClick={(e) => handleAddToWishlist(e, product.isbn)}> 
                                                                    <span>Auf die Merkliste</span>
                                                                </button>
                                                                <button className="umbButton desktopButtonItem" onClick={() => navigate('/suche')}> 
                                                                    <span>Zurück zur Suche</span>
                                                                </button>
                                                            </div>
                                                              
                                                        </div>
                                                    
                                                </div>
                                                
                                        

                                             
                                                <div className="gridText"> 

                                          
                                                    
                                                      
                                                    {texte && texte.length > 0 ? (
                                                        texte.map((texte, index) => (
                                                        
                                                            <div key={index}>

                                                               
                                                           

                                                                {texte.autoreninfo && 
                                                                    <div>
                                                                         
                                                                        
                                                                        <div className="zusatzTextDesk">
                                                                            <h4>Autorenportrait</h4>
                                                                            {texte.autoreninfo}
                                                                        </div> 
                                                                    </div>
                                                                }
                                                            </div>
                                                            /* 
                                                                {texte.kurztext && <div>Kurztext: {texte.kurztext}</div>}
                                                                {texte.schlagzeile && <div>Schlagzeile: {texte.schlagzeile}</div>} */
                                                        ))
                                                        ) : (
                                                        <p></p>
                                                        )
                                                    }
                                                                
                                                    
                                                     <br />
                                                     <br />
                                                     
                                                </div>
                                               
                                            </div>          
  
                                     </div>    
                                    ))   
                                ) : (
                                    <p></p>
                                )}

                                   
                    </div>        
                </div>
    );
  };
  
  export default DetailPage;


